import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { colors } from '../../../constants/colors';
import { fontFamily, fontSize } from '../../../constants/text';

const Root = styled.div`
  background: ${colors.mrBlueSky};
  padding: 20px 26px;
  text-align: left;
`;

const PrimaryTitle = styled.div`
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.medium};
  color: ${colors.theWhiteAlbum};
`;

export default class Header extends PureComponent {
  render() {
    return (
      <Root>
        <PrimaryTitle>Solv helps you find and book urgent care visits.</PrimaryTitle>
      </Root>
    );
  }
}
